import { gql } from '../../__generated__/gql'

export const ADD_PCO_SONG_ARRANGEMENT = gql(`
  mutation addPcoSongArrangement(
    $songId: Int!
    $songStructure: [JSON!]
    $songKey: String!
    $chordCharts: [JSON!]!
    $capo: String!
  ) {
    addPcoSongArrangement(
      input: {
        songId: $songId
        songStructure: $songStructure
        songKey: $songKey
        chordCharts: $chordCharts
        capo: $capo
      }
    ) {
      userSetup {
        id
        charts
        lyrics
        mixer
        capo
        songKey
        songPcoInfo
      }
    }
  }
`)
